import axios from "axios";
import { fechaISO, addMaintenanceURL } from "@/constants";

export default {
    name: "mantenimiento",
    components: {},
    data() {
        return {
            systemId: "",
            fecha: "",
            vencimiento: "",
            notas: "",
            alarmas: ""
        };
    },

    computed: {
        puedeGrabar() {
            return this.fecha && this.vencimiento && this.vencimiento > this.fecha && this.notas;
        },

        loggedIn() {
            return localStorage.loggedIn;
        }
    },

    async mounted() {
        if (!localStorage.loggedIn) {
            const loginpath = window.location.pathname;
            this.$router.push({ name: "acceso", query: { redirect: loginpath } });
        }

        const now = new Date();
        this.fecha = fechaISO(now);
        this.vencimiento = fechaISO(now.setMonth(now.getMonth() + 6));
        this.systemId = this.$route.params.systemId;

        /*
        await axios.post("https://domotec.com.uy/api/systemEvent/create");
        await axios.post("https://domotec.com.uy/api/systemEvent/create");
        await axios.post("https://domotec.com.uy/api/systemEvent/create");
        */
    },

    methods: {
        agregarArchivoClick() {
            window.alert("Function not yet available");
        },

        volverClick() {
            //this.$router.go(-1);
            this.$router.back();
        },

        async guardarClick() {
            try {
                await axios.post(
                    addMaintenanceURL(),
                    {
                        token: localStorage.userToken,
                        system_id: this.systemId,
                        notes: this.notas,
                        maintenance_date: this.fecha,
                        maintenance_valid_until: this.vencimiento,
                        files: []
                    },
                    { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
                );
                this.$router.go(-1);
            } catch (e) {
                window.console.log("ERROR!!", e);
                const loginpath = window.location.pathname;
                this.$router.push({ name: "acceso", query: { redirect: loginpath } });
            }
        }
    }
};
